(function () {
  function injectText(slide) {
    if (slide.dataset.overlayInjected) return;
    var text = slide.getAttribute('data-overlay-text');
    if (!text) return;

    var target = slide.querySelector('[data-product-image-main]');
    if (!target) return;

    var label = document.createElement('div');
    label.className = 'pdp-overlay-text';
    label.textContent = text;
    target.appendChild(label);
    slide.dataset.overlayInjected = 'true';
  }

  function scanSlides(root) {
    (root || document).querySelectorAll('[data-overlay-text]').forEach(injectText);
  }

  document.addEventListener('DOMContentLoaded', function () {
    scanSlides();

    var containers = document.querySelectorAll('[data-product-photos]');
    containers.forEach(function (container) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) scanSlides(node);
          });
        });
      });
      observer.observe(container, { childList: true, subtree: true });
    });
  });
})();